import { useEffect } from 'react';

interface SEOHeadProps {
  title?: string;
  description?: string;
  keywords?: string;
  ogTitle?: string;
  ogDescription?: string;
  ogImage?: string;
  ogType?: string;
  canonical?: string;
  noindex?: boolean;
}

const SEOHead = ({
  title,
  description,
  keywords,
  ogTitle,
  ogDescription,
  ogImage,
  ogType = 'website',
  canonical,
  noindex = false,
}: SEOHeadProps) => {
  useEffect(() => {
    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://agro-innovazioni.it';
    
    if (title) {
      document.title = title;
    }
    
    const updateMetaTag = (name: string, content: string, property = false) => {
      const selector = property ? `meta[property="${name}"]` : `meta[name="${name}"]`;
      let meta = document.querySelector(selector) as HTMLMetaElement;
      if (!meta) {
        meta = document.createElement('meta');
        if (property) {
          meta.setAttribute('property', name);
        } else {
          meta.setAttribute('name', name);
        }
        document.head.appendChild(meta);
      }
      meta.content = content;
    };

    if (description) {
      updateMetaTag('description', description);
    }
    
    if (keywords) {
      updateMetaTag('keywords', keywords);
    }
    
    if (ogTitle) {
      updateMetaTag('og:title', ogTitle, true);
    }
    
    if (ogDescription) {
      updateMetaTag('og:description', ogDescription, true);
    }
    
    if (ogImage) {
      updateMetaTag('og:image', ogImage, true);
    }
    
    updateMetaTag('og:type', ogType, true);
    updateMetaTag('og:url', `${siteUrl}${window.location.pathname}`, true);
    
    if (noindex) {
      updateMetaTag('robots', 'noindex, nofollow');
    } else {
      updateMetaTag('robots', 'index, follow');
    }
    
    if (canonical) {
      let linkCanonical = document.querySelector('link[rel="canonical"]') as HTMLLinkElement;
      if (!linkCanonical) {
        linkCanonical = document.createElement('link');
        linkCanonical.rel = 'canonical';
        document.head.appendChild(linkCanonical);
      }
      linkCanonical.href = canonical;
    }

    return () => {
      // Cleanup handled by next SEOHead call
    };
  }, [title, description, keywords, ogTitle, ogDescription, ogImage, ogType, canonical, noindex]);

  return null;
};

export default SEOHead;